// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"651":"5b3130f3","686":"cfba6302","746":"e790a85b","858":"b42142fe"}[chunkId] + ".chunk.js";
};